// translations/pages/landing/de.js

export const landingPageDE = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "Lokale KI-Lösungen mit Datenschutz im Fokus",
    "vision": "Die nächste Stufe der Produktivitätssteigerung: Organisation as a Service. KI-Mitarbeiter übernehmen Arbeit von der Idee bis zum geprüften Ergebnis.",
    "intro": "Wir erforschen, entwickeln und integrieren Technologien der künstlichen Intelligenz, des maschinellen Lernens und der Datenverarbeitung. Daraus entstehen eigene Produkte und kundenspezifische Lösungen, die Daten lokal analysieren, strukturieren, anonymisieren und schützen — sowie mit [Veridion](veridion) vollautomatisierte KI-Mitarbeiter, die gemeinsam mit Menschen ganze Arbeitsbereiche im Unternehmen übernehmen.",
    "detail": "Software, die wir beim Kunden installieren, läuft in seiner eigenen Infrastruktur und braucht keine Cloud-Anbindung. Dokumente, Daten und Sprachmodelle bleiben im Haus."
  },
  "partners": {
    "title": "Partner, die uns vertrauen",
    "subtitle": "Unternehmen und Forschungseinrichtungen, bei denen unsere KI-Organisation produktiv im Einsatz ist.",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\nEye-Tracking- und Biosignal-Lösungen für Ihre Forschung",
        "description": [
          "BiSigma ist spezialisiert auf Systeme zur Messung und Analyse von Biosignalen sowie auf hochpräzise Eye-Tracking-Lösungen für Wissenschaft, Klinik und industrielle Forschung.",
          "Die pAIoneer Labs GmbH hat bei BiSigma die Softwareentwicklung vollständig durch KI ersetzt, die erfolgreich Software zur Messung und Analyse von Biosignalen entwickelt und kontinuierlich weiterentwickelt."
        ],
        "cta": "BiSigma besuchen"
      }
    }
  },
  "products": {
    "title": "Produkte",
    "subtitle": "Wir verkaufen Software als Desktop-Anwendung für den Arbeitsplatz, als Server-Software on-premises oder in der Cloud des Kunden und als Abonnement auf unserer Plattform wie den [Trading-Assistenten](finance), den unsere KI-Mitarbeiter selbst entwickeln. Dazu bauen wir KI-Systeme nach Kundenanforderung, beraten und schulen.",
    "partnerLabel": "Partnerprodukt",
    "priceOnRequest": "Preis auf Anfrage",
    "request": "Anfrage senden",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveil erkennt und anonymisiert personenbezogene Daten in Word-, Excel-, OpenDocument-, PDF- und Textdateien, bevor sie in KI-Werkzeuge, Tests, Analysen oder an Dritte gehen. Die Erkennung kombiniert {presidio}, {spacy} und {flair} und arbeitet auf Deutsch, Englisch, Französisch, Italienisch und Spanisch.",
          "Die Desktop-Version läuft eigenständig auf handelsüblichen Rechnern mit Windows, macOS oder Linux, ohne GPU und ohne Netzwerkabhängigkeit; die Dateien verlassen den Arbeitsplatz nicht. Die API-Version wird in der Infrastruktur des Kunden betrieben, on-premises oder in der eigenen Cloud, und bindet die Anonymisierung in bestehende Systeme und Workflows ein.",
          "Der Replace-Modus ersetzt personenbezogene Daten durch Platzhalter für die Compliance-Dokumentation, der Fake-Modus durch plausible Ersatzwerte für Testumgebungen; die Dokumentstruktur bleibt erhalten. Mit AnonChat geht ein anonymisiertes Dokument erst nach einer Vorschau an ChatGPT, Claude, Gemini oder ein internes Sprachmodell."
        ],
        "cta": "Kyveil ansehen"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "Ein Schöpfer, unendlich viele Lösungen.",
        "text": [
          "Die Firmen-KI der pAIoneer Labs GmbH: Sie steuert das gesamte Unternehmen, als vollständige Organisation aus KI-Mitarbeitern mit Business Units von der Softwareentwicklung über Elektronik und Quantum Computing bis zu Vertrieb und Verwaltung, geführt von einer eigenen Koordinationsebene.",
          "Diese Belegschaft führt Projekte, Buchhaltung, Firmenwissen, Recherche, Entwicklung und Datenanalyse eigenständig zu Ende. Ihre Kommunikation ist spieltheoretisch optimiert, und braucht sie eine Fähigkeit, die es noch nicht gibt, baut sie dafür ein eigenes KI-System.",
          "Betrieben wird sie on-premises, in der eigenen Cloud oder auf unserer Plattform. Den [Trading-Assistenten](finance) dort entwickelt sie selbst, und im Chat ist sie dessen KI."
        ],
        "points": [
          "Integriert sich in jeden Prozess",
          "Lernt eigenständig dazu",
          "Erschafft fehlende Fähigkeiten selbst",
          "Planbar in festen Zyklen"
        ],
        "cta": "Veridion ansehen"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddy ist ein KI-basiertes, modulares Agentensystem für Unternehmen und automatisiert administrative Büroaufgaben.",
          "Fünf Rollen decken den Arbeitsalltag ab: Der Assistent koordiniert Termine, entwirft E-Mails und erledigt tägliche Aufgaben. Der Coach begleitet die emotionalen und sozialen Seiten des Berufsalltags, hilft bei Konflikten und unterstützt die persönliche Entwicklung. Der Datenschutzhelfer beantwortet Fachfragen zu Datenschutz und Privatsphäre und ist auf weitere Spezialgebiete wie Brandschutz oder Compliance trainierbar. Der Schulungstrainer erstellt Weiterbildungspläne, Onboardings und Schulungsmodule, und der Berater analysiert hochgeladene Dokumente, unterstützt Entscheidungen und gibt strategische Empfehlungen.",
          "RoBuddy wird zu 100 % nach deutschen Standards (DSGVO, BSI-Grundschutz) gehostet und verwaltet und lässt sich nahtlos an Nextcloud oder jedes Netzlaufwerk anbinden.",
          "RoBuddy ist das agentische System für die Büroarbeit und lässt sich mit Veridion zu einer Firmen-KI verbinden, die das gesamte Unternehmen umfasst: RoBuddy übernimmt die Aufgaben am Arbeitsplatz, Veridion bindet die Systeme und Daten des Unternehmens an."
        ],
        "cta": "RoBuddy ansehen",
        "vendorNote": "RoBuddy ist ein Produkt der Dr. Hornecker Software-Entwicklung und IT-Dienstleistungen. Der Vertrieb erfolgt durch die pAIoneer Labs GmbH."
      }
    }
  },
  "platformNote": {
    "title": "SaaS-Plattform",
    "description": "Diese Anwendung nutzen Sie im Abonnement direkt im Browser, ohne Installation. Sie läuft auf unserer eigenen Plattform, die Anmeldung verlangt einen zweiten Faktor, und alle KI-Aufrufe gehen über einen zentralen Zugang mit festen Kontingenten.",
    "apps": {
      "finance": {
        "name": "KI-Trading-Assistent",
        "text": "Sie binden Ihr Wertpapierdepot an, stellen Fragen zu Ihren Positionen in natürlicher Sprache und sehen, welche Meldungen die Kurse bewegt haben. Für jedes Finanzinstrument berechnet ein eigenes, täglich neu trainiertes Machine-Learning-Modell die Prognose, und eine Automatik kann die Signale handeln. Entwickelt wird der Assistent von unseren KI-Mitarbeitern; im Chat sind sie auch seine KI.",
        "cta": "Trading-Assistent ansehen"
      }
    }
  },
  "services": {
    "title": "Leistungsschwerpunkte",
    "veridion": {
      "title": "KI-Mitarbeiter",
      "description": "Ganze Arbeitsfelder, besetzt mit KI-Mitarbeitern, die sich in die Prozesse und Werkzeuge des Unternehmens integrieren und Arbeit eigenständig zu Ende führen. So arbeiten wir selbst: Die pAIoneer Labs GmbH läuft darüber.",
      "cta": "Veridion ansehen",
      "features": [
        "Organisation as a Service",
        "Business Units aus KI-Mitarbeitern",
        "Spieltheoretisch optimierte Kommunikation",
        "On-premises oder eigene Cloud"
      ]
    },
    "custom": {
      "title": "Kundenspezifische KI-Systeme",
      "description": "Wir entwickeln Systeme für Analyse, Verarbeitung, Strukturierung, Anonymisierung und Schutz von Daten nach Kundenanforderung und integrieren sie in lokale oder kundeneigene IT-Infrastrukturen.",
      "features": [
        "Betrieb ohne Cloud",
        "Produktentwicklung",
        "Prototypen",
        "Forschungs- und Entwicklungsprojekte"
      ]
    },
    "dataanalysis": {
      "title": "Datenanalyse im Gespräch",
      "description": "Ein KI-Mitarbeiter beantwortet Fragen an angebundene Datenquellen. Er liest Kataloge, Schemas und Spalten der Datenbanken, legt vor dem Datenzugriff einen Analyseplan vor und klärt Mehrdeutigkeiten.",
      "features": [
        "SQL-Datenquellen",
        "Korrelation und Regression",
        "Tabellen und Diagramme",
        "PDF- und PowerPoint-Export"
      ]
    },
    "memory": {
      "title": "Firmengedächtnis",
      "description": "Ein Gedächtnis statt einer Dokumentensuche: Fakten, Entscheidungen, Aufgaben und Abläufe, verknüpft mit den Projekten, Personen, Systemen und Dokumenten, zu denen sie gehören, samt der Zeit, in der sie gelten. Es wächst von selbst aus Gesprächen, Meetings und Arbeitsergebnissen; eine neuere Entscheidung ersetzt die ältere zum selben Thema, nichts geht verloren.",
      "features": [
        "Wissensgraph",
        "Fakten mit Zeitbezug",
        "Entscheidungen, nie verloren",
        "Zugriff nach Zuständigkeit"
      ]
    },
    "elektronik": {
      "title": "Elektronik & Firmware",
      "description": "Hardwarenahe Entwicklung als Leistung: Schaltungsentwurf und Simulation als digitaler Zwilling, Firmware bis auf den Sensor, Bewertung von Bauteilen und Alternativen vor der Fertigung.",
      "features": [
        "Digitale Zwillinge",
        "Embedded-Firmware",
        "Datenblatt-Analyse",
        "Bauteil-Bewertung"
      ]
    },
    "quantum": {
          "title": "Souveräne LLMs & Quanten-KI",
          "description": "Unser Ziel unter Veridion: kompakte Sprachmodelle Made in Germany entwickeln, die künftig mit großen Modellen aus den USA und China konkurrieren werden, sowie eigene Quanten-Transformer.",
          "cta": "Quantum ansehen",
          "features": [
                "Sprachmodelle Made in Germany",
                "Quanten-Transformer",
                "Eigene Quantum IDE",
                "KI entwickelt KI"
          ]
    },
    "kyveil": {
      "title": "Lokale No-GPU-Anonymisierung",
      "description": "Kyveil anonymisiert personenbezogene Daten lokal, als Desktop-Anwendung auf handelsüblichen Rechnern mit Windows, macOS oder Linux oder als REST-API in der Infrastruktur des Kunden, ohne Cloud-Zwang und ohne GPU.",
      "cta": "Kyveil ansehen",
      "features": [
        "Anonymisierung vor KI",
        "NLP-PII-Erkennung",
        "Windows, macOS, Linux",
        "REST-API on-premises"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "KI-gestützte Softwareentwicklung braucht belastbaren Kontext. IDD hält Ziele, Nicht-Ziele, Szenarien, Agent-Regeln und Entscheidungen als nutzbares Projektgedächtnis fest.",
      "cta": "IDD ansehen",
      "features": [
        "Agentische Entwicklung",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "Szenarien als Tests"
      ]
    },
    "finance": {
      "title": "Finance & Marktanalyse",
      "description": "Hinter dem Trading-Assistenten steht eine eigene Business Unit aus digitalen Mitarbeitern: KI-Data-Scientists und Finance-Experten. Sie werten Nachrichten in Echtzeit aus, analysieren die Emotionen der Finanznachrichten und rechnen im Chat selbst auf den Marktdaten: Korrelationen, Regressionen, Diagramme und die Bilanz der eigenen Prognosen, jede Zahl aus einem ausgeführten Rechenschritt. Darunter arbeiten eine Machine-Learning-Prognose je Finanzinstrument und ein automatischer Paper- und Live-Handel.",
      "cta": "Finance ansehen",
      "features": [
        "KI-Data-Scientists & Finance-Experten",
        "Nachrichten in Echtzeit, mit Emotionsanalyse",
        "ML-Prognose je Finanzinstrument",
        "Automatischer Handel"
      ]
    },
    "consulting": {
      "title": "Beratung",
      "description": "Wir beraten technisch, organisatorisch und strategisch bei Einführung, Absicherung und regelkonformem Einsatz von KI.",
      "features": [
        "AI Governance",
        "Datenmanagement",
        "Datenschutz",
        "Informationssicherheit"
      ]
    }
  },
  "contact": {
    "title": "Kontakt",
    "addressLabel": "Anschrift",
    "phoneLabel": "Telefon",
    "emailLabel": "E-Mail",
    "cta": "Nachricht schreiben"
  }
};
